<template>
  <div>
    <section
      v-show="
        deviceTp === 'WEB' &&
        isShowEventPopup &&
        $route.matched[0].name == 'store' &&
        popupImage
      "
      class="pop_wrap"
    >
      <div class="popupEvent">
        <router-link :to="popupUrl" target="_blank">
          <img :src="popupImage" :alt="popupTitle" />
        </router-link>
        <button class="week_close" @click="checkWeekClosePopup()">
          <span></span>
          <span></span>
        </button>
      </div>
      <div
        v-if="isShowEventPopup"
        class="popup_opacity"
        @click="closeEvtPopup()"
      ></div>
    </section>
    <section
      v-show="
        deviceTp === 'MO' &&
        isShowEventPopup &&
        $route.matched[0].name == 'store' &&
        popupImage
      "
      class="pop_wrap"
    >
      <div class="popupEvent">
        <router-link :to="popupUrl">
          <img :src="popupImage" :alt="popupTitle" />
        </router-link>
        <div class="popupBtnWrap">
          <div class="popupCheckWrap">
            <button @click="checkWeekClosePopup()">
              일주일간 보지 않기
            </button>
          </div>
          <span class="cursor closeBtn" @click="closeEvtPopup()">닫기</span>
        </div>
      </div>
      <div
        v-if="isShowEventPopup"
        class="popup_opacity"
        @click="closeEvtPopup()"
      ></div>
    </section>
  </div>
</template>
<script>
import { showPopup } from '@/store/constants'
import {
  // AUTH_REFRESH,
  STORE_POPUP
} from '@/store/types'
import { mapGetters } from 'vuex'
export default {
  name: 'MainPopup',
  data() {
    return {
      showPopup,
      isShowEventPopup: true,
      checked: false,
      window: {
        width: 0
      }
    }
  },
  computed: {
    ...mapGetters(['getLoading', 'isAuthLoading', 'getPopup']),
    deviceTp() {
      if (480 < this.window.width) {
        return 'WEB'
      } else {
        return 'MO'
      }
    },

    isLoading() {
      if (this.isAuthLoading || this.getLoading) return true
      return false
    },
    layout() {
      return `${this.$route.meta.layout || 'default'}-layout`
    },
    cookieNm() {
      if (this.universityName) {
        return this.universityName.trim()
      } else {
        return ''
      }
    },
    deviceCheckPopup() {
      return (
        this.getPopup?.popup?.find((e) => e.deviceTp === this.deviceTp)
          ?.url[0] || ''
      )
    },
    popupImage() {
      return this.deviceCheckPopup?.bannerUrl || ''
    },
    popupUrl() {
      return this.deviceCheckPopup?.linkUrl || ''
    },
    popupTitle() {
      return this.deviceCheckPopup?.bannerTitle || ''
    }
  },
  beforeMount() {
    let value = document.cookie.match(
      `(^|;) ?evtPopupYn${this.cookieNm}1=([^;]*)(;|$)`
    )
    value ? (this.isShowEventPopup = false) : ''
  },
  async mounted() {
    let token = localStorage.getItem('token')

    if (token) {
      try {
        // await this.$store.dispatch(AUTH_REFRESH)
      } catch (err) {
        // console.log(err)
      }
    }
    await this.$store.dispatch(STORE_POPUP)
    this.$cookies.get('pcMode') === 'isPcModeTrue'
      ? document
          .getElementById('viewport')
          .setAttribute('content', process.env.VUE_APP_VIEWPORT_PCMODE)
      : ''
  },
  methods: {
    checkWeekClosePopup() {
      var todayDate = new Date()
      todayDate.setHours(168)
      document.cookie =
        `evtPopupYn${this.cookieNm}1` +
        '=' +
        escape('N') +
        '; path=/; expires=' +
        todayDate.toGMTString() +
        ';'
      this.isShowEventPopup = false
    },
    closeEvtPopup() {
      this.isShowEventPopup = false
    }
  }
}
</script>
<style lang="scss" scoped>
// apply
.pop_wrap {
  position: fixed;
  display: flex;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: 99;
  .popupEvent {
    z-index: 99;
    a {
      display: block;
      img {
        display: block;
        border-top-left-radius: 25px;
        border-top-right-radius: 25px;
      }
    }
  }
}
.week_close {
  position: absolute;
  top: 15px;
  right: 20px;
  width: 27px;
  height: 27px;
  span {
    position: absolute;
    top: 50%;
    right: 0;
    width: 100%;
    height: 2px;
    background-color: #000;
    &:first-child {
      transform: rotate(45deg);
    }
    &:last-child {
      transform: rotate(-45deg);
    }
  }
}
// pad
@media (max-width: 1200px) {
  .pop_wrap {
    display: none;
  }
}
// mobile
@media (max-width: 480px) {
  .pop_wrap {
    display: flex;
    width: 100%;
    height: 100%;
    .popupEvent {
      align-self: flex-end;
      width: 100%;
      a {
        img {
          width: 100%;
          border-top-left-radius: 0;
          border-top-right-radius: 0;
        }
      }
    }
  }
  .popup_opacity {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #000;
    opacity: 0.5;
  }
  .popupBtnWrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 20px;
    background-color: #ffffff;
    color: #7f7f7f;
    .cursor {
      font-weight: 600;
      font-size: 14px;
    }
    button {
      font-size: 14px;
    }
  }
}
</style>
